import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsLoggedIn } from '@ekonavi/base-test';
import { useResolveNavigate } from '../hooks/use-resolve-navigate';

interface AutoRouterProps {
  children: React.ReactNode;
}

export function AutoRouter({ children }: AutoRouterProps) {
  const resolveNavigate = useResolveNavigate();
  const location = useLocation();
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    // If logged in and on home page, redirect to dashboard
    if (isLoggedIn && location.pathname === '/') {
      resolveNavigate({ path: '/painel', fadeOut: false });
    }
    // Auth pages remain accessible - redirection happens within the AuthUI component upon successful login
  }, [isLoggedIn, location.pathname, resolveNavigate]);

  return <>{children}</>;
}